export const en = {
  readOurSupportDocs: 'View the guide',
  close: 'Close',
  help: '💡 Help'
};

export type Translations = typeof en;
